import HBEmpty from "@/components/HBEmpty";
import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import Image from "@/components/Image";
import { useLogin } from "@/components/LoginModal";
import PinButton from "@/components/PinCard/actions/button";
import { PinEditorModal } from "@/components/PinEditor";
import ShareDropdown from "@/components/ShareDropdown";
import SimilarMaterialList from "@/components/SimilarMaterialList";
import { EVENT } from "@/constants/event";

import {
  deletePin,
  getPin,
  getSimiliarMaterial,
  likePin,
  report,
  unlikePin,
} from "@/services";
import displayNum from "@/utils/displayNum";
import { ContentType, getContentType } from "@/utils/getContentType";
import imageUrl from "@/utils/imageUrl";
import isEditingElement from "@/utils/isEditingElement";
import useRequest from "@/utils/useReq";
import { useKeyPress } from "ahooks";
import { Affix, Button, Modal } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import qs from "qs";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Case, Else, If, Switch, Then, When } from "react-if";
import Board from "./Board";
import styles from "./index.module.less";
import ModalOperate from "./ModalOperate";
import PinHead from "./PinHead";
import PinMaterial, { PinMaterialRedirect } from "./PinMaterial";
import User from "./User";
// import PinMoreDropdown from "./PinMoreDropdown";
import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import { PIN_MATERIAL_STATUS } from "@/constants/pinMaterialStatus";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import { SHORTCUT } from "@/constants/shortcut";
import { isBigCompanyByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { addHistory } from "@/services/history";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import { isGdMerged } from "@/utils/gaoding";
import { isBigCompanyByGdVip } from "@/utils/gaodingVip";
import { gdSlsReportError } from "@/utils/gdSlsRum";
import getNextDetailsSetp, {
  getNextViewImageSetp,
} from "@/utils/getHistorySetp";
import {
  DIRECTION,
  useListenScrollDirection,
} from "@/utils/hooks/useListenScrollDirection";
import { PRESETS_CONDITION, stewardInstance } from "@/utils/steward";
import ReportModal from "../ReportModal";
import UserGuideTooltip from "../UserGuideTooltip";
// import PinDetailAiTools from "./AiTools";
import { PIN_PRIVATE_STATUS } from "@/constants/pin";
import useABTest from "@/utils/hooks/useABtest";
import { openBindTelModal } from "@/utils/open";
import dynamic from "next/dynamic";
import PinAIInfo from "./PinAIInfo";
import PinTitle from "./PinTitle";
import Recommend from "./Recommend";
import PinSeries from "./Series";
import PinTopic from "./Topic";
const actionHeight = 64;

const PinDetailAiTools = dynamic(() => import("./AiTools"), {
  ssr: false,
});

// 素材展示模块吸顶距离
const viewStickyTop = 48;
const viewPadding = 24;
const offsetHeight = {
  haveTitle: 108,
  noTitle: 84,
};
const isMaterialPin = (pin) => {
  return (
    pin?.file_material?.status === PIN_MATERIAL_STATUS.AVAILABLE &&
    pin?.file_material?.material_category !== "其他" &&
    pin?.material_info &&
    pin?.material_info.err !== 404
  );
};

export default function PinDetail(props) {
  const router = useRouter();
  const {
    user,
    userReady,
    pinQueue,
    headerHeight,
    pinOpenType,
    currentPin = null,
    config,
    vips,
  } = useAppStore(
    ({
      user,
      userReady,
      pinQueue,
      headerHeight,
      currentPin,
      pinOpenType,
      config,
      vips,
    }) => ({
      user,
      userReady,
      pinQueue,
      headerHeight,
      currentPin,
      pinOpenType,
      config,
      vips,
    })
  );
  const { login } = useLogin();
  const {
    pinId,
    pin: initPins,
    file,
    currentSrc,
    onClose,
    isModal,
    relatedBoards,
    searchWord: _searchWord,
  } = props;
  const searchWord = _searchWord || router.query?.searchWord;
  const [pin, setPin] = useState(initPins || null);

  const indexRef = useRef(0);

  const style = {
    position: "sticky",
    top: `${isModal ? actionHeight : headerHeight + actionHeight}px`,
  };
  const stickyRef = useRef();
  const rightContent = useRef();
  const viewContentRef = useRef();
  const stickyOffsetHeight = useMemo(() => {
    return isModal ? actionHeight : headerHeight + actionHeight;
  }, [headerHeight, isModal]);
  const getParentTopDistance = (dom) => {
    if (!dom) {
      return;
    }
    // 获取到父元素顶部的距离
    const childTop = dom.getBoundingClientRect().top;
    const parentTop = dom.parentElement.getBoundingClientRect().top;
    return childTop - parentTop;
  };

  const initOffsetTop = useMemo(() => {
    const haveTitle =
      pin?.raw_text ||
      (pin?.source && !pin?.domain?.hide_origin) ||
      pin?.tags?.length > 0;
    return haveTitle ? offsetHeight.haveTitle : offsetHeight.noTitle;
  }, [pin]);
  const rightContentUp = (preDirection) => {
    if (!stickyRef.current) {
      return;
    }
    // 距离视口高度距离
    const viewportTopDistance = stickyRef.current.getBoundingClientRect().top;

    // 如果距视口高度大于等于所计算高度则吸顶
    if (viewportTopDistance >= stickyOffsetHeight) {
      stickyRef.current.style.position = "sticky";
      stickyRef.current.style.top = `${stickyOffsetHeight}px`;
      return;
    }
    // 判断上次滚动方向是否和当前滚动方向相反
    if (!preDirection || preDirection === DIRECTION.down) {
      // 距离父元素的顶部距离
      const parentTopDistance = getParentTopDistance(stickyRef.current);

      // 整个详情模块的高度
      const contentHeight = detailRef.current.getBoundingClientRect().height;
      const stickyHeight = stickyRef.current.getBoundingClientRect().height;

      if (parentTopDistance + stickyHeight <= contentHeight) {
        stickyRef.current.style.position = "relative";
        stickyRef.current.style.top = `${parentTopDistance - initOffsetTop}px`;
      }
    }
  };
  const rightContentDown = (preDirection) => {
    if (!stickyRef.current) {
      return;
    }
    // 计算吸底之后的top值
    let top = window.innerHeight - stickyRef.current.offsetHeight;
    const targetTop = stickyRef.current.offsetTop;

    // 距离视口底部距离
    const viewportBottomDistance =
      window.innerHeight - stickyRef.current.getBoundingClientRect().bottom;

    if (viewportBottomDistance >= 0) {
      stickyRef.current.style.position = "sticky";
      stickyRef.current.style.top = `${
        top < stickyOffsetHeight ? top : stickyOffsetHeight
      }px`;
      return;
    }
    if (!preDirection || preDirection === DIRECTION.up) {
      if (viewportBottomDistance) {
        stickyRef.current.style.position = "relative";
        stickyRef.current.style.top = `${targetTop - initOffsetTop}px`;
      }
    }
  };
  const viewUp = (preDirection) => {
    if (!viewContentRef.current) {
      return;
    }
    // 只有屏幕高度小于图片展示的时候才需要处理
    const needListen =
      window.innerHeight -
        viewContentRef.current.getBoundingClientRect().height -
        viewPadding <
      0;

    if (needListen) {
      const top = isModal ? viewStickyTop : headerHeight + viewStickyTop;
      const viewportTopDistance = Math.round(
        viewContentRef.current.getBoundingClientRect().top
      );
      // 满足条件吸顶
      if (viewportTopDistance >= top) {
        viewContentRef.current.style.position = "sticky";
        viewContentRef.current.style.top = `${top}px`;
        return;
      }
      const parentTopDistance = getParentTopDistance(viewContentRef.current);
      // 切换了滚动方向之后则允许滚动
      if (!preDirection || preDirection === DIRECTION.down) {
        // 距离视口底部距离
        viewContentRef.current.style.position = "relative";
        viewContentRef.current.style.top = `${parentTopDistance}px`;
      }
    }
  };

  const viewDown = (preDirection) => {
    if (!viewContentRef.current) {
      return;
    }

    const diffHeight =
      window.innerHeight -
      viewContentRef.current.getBoundingClientRect().height -
      viewPadding;

    // 只有屏幕高度小于图片展示的时候才需要处理
    if (diffHeight < 0) {
      // 距离视口底部距离
      const viewportBottomDistance = Math.round(
        window.innerHeight -
          viewContentRef.current.getBoundingClientRect().bottom
      );
      // 满足条件吸底
      if (viewportBottomDistance >= viewPadding) {
        viewContentRef.current.style.position = "sticky";
        viewContentRef.current.style.top = `${diffHeight}px`;
        return;
      }
      // 切换滚动方向则允许滚动
      if (!preDirection || preDirection === DIRECTION.up) {
        const parentTopDistance = getParentTopDistance(viewContentRef.current);
        viewContentRef.current.style.position = "relative";
        viewContentRef.current.style.top = `${parentTopDistance}px`;
      }
    }
  };
  useListenScrollDirection(
    // 向上滚动
    (preDirection) => {
      rightContentUp(preDirection);
      viewUp(preDirection);
    },
    (preDirection) => {
      rightContentDown(preDirection);
      viewDown(preDirection);
    },
    isModal ? () => document.querySelector(".pinDetailModal") : undefined
  );
  useEffect(() => {
    // 切换采集后重置滚动样式;
    if (viewContentRef.current) {
      viewContentRef.current.style.position = "sticky";
      viewContentRef.current.style.top = `${
        isModal ? viewStickyTop : headerHeight + viewStickyTop
      }px`;
    }
  }, [pinId, isModal, headerHeight]);
  // const previewModal = useRef(null); // 查看大图弹窗
  const detailRef = useRef(null);
  // const [offsetTop, setOffsetTop] = useState(0);
  const [notFoundPin, setNotFountPin] = useState(false);

  const pinFile = useMemo(() => {
    return file || pin?.file;
  }, [file, pin]);

  const newPinId = useMemo(() => {
    return (pin?.pin_id || pinId).toString();
  }, [pinId, pin?.pin_id]);
  const initRef = useRef(true);

  useEffect(() => {
    if (getContentType(pin) === ContentType.material) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_MATERIAL_DETAILS_ENTER_TIMES,
        {
          needRemoveTrigger: true,
        }
      );
    }
  }, [pin]);

  const watermarkAb = useABTest("material_detail_watermark", "new", {
    new: "new",
    old: "old",
  });

  const hideRelatedTopicAB = useABTest("hide_related_topic_ab", "0", {
    show: "0",
    hide: "1",
  });

  const { run: runReload } = useRequest(
    async () => {
      if (!pinId) {
        return;
      }

      // 服务端渲染第一次则没有必要重复请求数据
      if (initRef.current && initPins) {
        pvTracker({
          ...getPageData(),
          scene_name: initPins.raw_text || undefined,
        });
        initRef.current = false;
        return;
      }

      const result = await getPin({
        pin_id: pinId,
        pins: 20,
        ignoreMessage: true,
        related_topic: "material",
      });

      const pin = result?.pin || null;

      if (result.err === 404) {
        if (isModal) {
          setNotFountPin(true);
        } else {
          router.push("/404", `/pins/${pinId}`);
        }
      } else if (!pin) {
        // 记录一下其他错误场景
        gdSlsReportError(result.msg || result.err);
      } else {
        setNotFountPin(false);

        setPin(pin);
        if (user) {
          addHistory({
            type: "pin",
            record: result?.pin,
            id: pinId,
          });
        }

        let { modalImg } = qs.parse(location.search.slice(1));
        if (modalImg) {
          const isMaterial = isMaterialPin(pin);
          let currentPreview = getCurrentPreview(
            pin,
            pin.file,
            user,
            isMaterial
          );
          useAppStore.setState({
            currentPreview,
          });
        }
      }
      // 区分素材采集还是普通采集需要等接口拿到数据后再报
      pvTracker({ ...getPageData(), scene_name: pin?.raw_text || undefined });
    },

    {
      refreshDeps: [pinId],
    }
  );

  const { runAsync: runDelete } = useRequest(deletePin, {
    manual: true,
  });
  const { runAsync: runLike } = useRequest(likePin, {
    manual: true,
  });
  const { runAsync: runUnlike } = useRequest(unlikePin, {
    manual: true,
  });
  const similiarList = useRequest(
    async () => {
      return getSimiliarMaterial({ pin_id: newPinId }).then((data) => {
        if (data.pins) {
          return {
            pins: data.pins.filter((item) => !!item),
          };
        } else {
          return data;
        }
      });
    },
    {
      refreshDeps: [newPinId],
    }
  );

  useEffect(() => {
    if (pin) {
      window.dispatchEvent(new CustomEvent(EVENT.UPDATE_PIN, { detail: pin }));
    }
  }, [pin]);

  const onToggleLike = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }
    if (!pin) {
      return;
    }
    if (pin?.liked) {
      const result = await runUnlike(pin.pin_id);
      if (!result.err) {
        setPin({
          ...pin,
          liked: false,
          like_count: pin.like_count - 1,
        });
      }
    } else {
      const result = await runLike(pin.pin_id);
      if (!result.err) {
        setPin({
          ...pin,
          liked: true,
          like_count: pin.like_count + 1,
        });
      }
    }
  }, [login, pin, runLike, runUnlike, user]);

  const onEdit = useCallback(async () => {
    await openBindTelModal();

    PinEditorModal.open({
      pinId: pin?.pin_id,
      onOk: () => {
        runReload();
      },
      onDelete: () => {
        if (isModal) {
          onClose && onClose();
          window.dispatchEvent(
            new CustomEvent(EVENT.DELETE_PIN, { detail: pin?.pin_id })
          );
        } else {
          router.push(`/boards/${pin?.board_id}`);
        }
      },
    });
  }, [isModal, onClose, pin, router, runReload]);

  const onPinSuccess = useCallback(() => {
    setPin({
      ...pin,
      repin_count: pin.repin_count + 1,
    });

    // 素材点击采集N次触发运营配置
    if (
      pin?.file_material?.status === PIN_MATERIAL_STATUS.AVAILABLE &&
      pin?.file_material?.material_category !== "其他" &&
      pin?.material_info &&
      pin?.material_info.err !== 404 &&
      !user?.vips?.length
    ) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_MATERIAL_COLLECT_TIMES
      );
    }
  }, [pin, user]);

  const onDelete = useCallback(() => {
    Modal.confirm({
      title: "删除采集",
      content: "确定要删除当前采集？",
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        await runDelete({ pin_id: pin?.pin_id });
        HBMessage.success("删除成功");
        if (isModal) {
          onClose && onClose();
          window.dispatchEvent(
            new CustomEvent(EVENT.DELETE_PIN, { detail: pin?.pin_id })
          );
        } else {
          router.push(`/boards/${pin.board_id}`);
        }
      },
    });
  }, [isModal, onClose, pin, router, runDelete]);
  const getCurrentPreview = (pin, pinFile, user, isMaterial) => {
    const origin = user?.user_id === pin?.user_id || !pin?.link;
    let currentPreview = {
      src: imageUrl(pinFile, {
        webp: false,
        origin,
      }),
      preview: {
        width: !origin && pinFile.width > 1200 ? 1200 : pinFile.width,
        height:
          !origin && pinFile.width > 1200
            ? Math.floor((pinFile.height * 1200) / pinFile.width)
            : pinFile.height,
        src: imageUrl(pinFile, {
          width: window.devicePixelRatio > 1 ? 1200 : 658,
        }),
      },
      pin: pin,
      pinFile,
      isMaterial,
    };
    // 不支持的图片格式
    if (["image/tiff"].includes(pinFile?.type)) {
      currentPreview.src = `https://${pinFile.bucket}.huaban.com/${pinFile.key}_png`;
      currentPreview.pinFile = { ...pinFile, type: "image/png" };
    }
    return currentPreview;
  };
  // 是否是素材
  const isMaterial = useMemo(() => {
    // 盲水印关联素材，ab实验，不展示素材信息模块
    if (watermarkAb?.old && pin?.file?.alias) {
      return false;
    }
    return isMaterialPin(pin);
  }, [pin, watermarkAb?.old]);

  const onShowPreview = useCallback(() => {
    if (!pin) return;
    let currentPreview = getCurrentPreview(pin, pinFile, user, isMaterial);
    useAppStore.setState({ currentPreview });
    let detailsSetp = getNextDetailsSetp();
    let historyData = typeof history?.state === "object" ? history?.state : {};

    history.pushState(
      isModal
        ? {
            ...historyData,
            detailsSetp,
            viewImageSetp: 1,
            firstPinId: pin.pin_id,
          }
        : { ...historyData },
      null,
      `/pins/${pin.pin_id}?modalImg=${encodeURIComponent(currentPreview.src)}`
    );
  }, [pin, pinFile, user, isModal, isMaterial]);

  const [prevPin, nextPin] = useMemo(() => {
    // 过滤折叠对象
    const pins = pinQueue.filter(
      (item) =>
        !item.folding_num && item.is_private !== PIN_PRIVATE_STATUS.VIOLATION
    );

    if (pins.length <= 0 || !pinId) {
      return [null, null];
    }
    let index = pins.findIndex((item) => item.pin_id == pinId);
    // 兼容画板的采集列表点击然后保留当前index位置
    if (index === -1) {
      index = indexRef.current;
    } else {
      indexRef.current = index;
    }

    return [pins[index - 1], pins[index + 1]];
  }, [pinQueue, pinId]);

  const onOperation = useCallback(
    (pin) => {
      // 下一张的时候判断当前查看大图弹窗是否打开
      let { modalImg } = qs.parse(location.search.slice(1));
      // 每次push的时候记录一下detailSetp
      let detailsSetp = getNextDetailsSetp();
      let viewImageSetp = getNextViewImageSetp();
      let historyData =
        typeof history?.state === "object" ? history?.state : {};
      if (modalImg) {
        let currentPreview = getCurrentPreview(pin, pin.file, user, isMaterial);
        useAppStore.setState({
          currentPin: { pinId: pin.pin_id, searchWord },
          // currentPreview,
        });
        window.history.pushState(
          isModal
            ? { ...historyData, detailsSetp, viewImageSetp }
            : { ...historyData },
          null,
          `/pins/${pin.pin_id}?modalImg=${encodeURIComponent(
            currentPreview.src
          )}`
        );
      } else {
        window.history.pushState(
          { ...historyData, detailsSetp },
          null,
          `/pins/${pin.pin_id}`
        );
        useAppStore.setState({ currentPin: { pinId: pin.pin_id, searchWord } });
      }
    },
    [isModal, user, isMaterial, searchWord]
  );

  // 快捷键：查看采集大图
  useKeyPress(
    SHORTCUT.FULL_IMAGE,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }
      let { modalImg } = qs.parse(location.search.slice(1));
      if (modalImg) {
        // 关闭
        // 重置currentPreview 数据
        useAppStore.setState({ currentPreview: {} });
        let detailsSetp = getNextDetailsSetp();
        let viewImageSetp = getNextViewImageSetp();
        // 判断用户有没有左右切换之后切换回原点
        let firstPinId = history?.state?.firstPinId;
        let historyData =
          typeof history?.state === "object" ? history?.state : {};
        // 修改当前url
        window.history.pushState(
          {
            ...historyData,
            detailsSetp,
            ...(location.pathname.includes(firstPinId)
              ? { viewImageSetp }
              : null),
          },
          null,
          `${location.pathname}`
        );
      } else {
        // 打开
        onShowPreview();
      }
    },
    {
      exactMatch: true,
    }
  );

  useKeyPress(
    SHORTCUT.EXIT,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      onClose && onClose();
    },
    {
      exactMatch: true,
    }
  );

  useKeyPress(
    SHORTCUT.SOURCE_URL,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (pin?.source && !pin?.domain?.hide_origin) {
        window.open(
          `/go?pin_id=${pin?.pin_id}&url=${encodeURIComponent(pin?.source)}`
        );
      }
    },
    {
      exactMatch: true,
    }
  );
  useKeyPress(
    SHORTCUT.DELETE_PIN,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (user?.user_id === pin?.user_id) {
        onDelete();
      }
    },
    {
      exactMatch: true,
    }
  );

  const onSelectPin = useCallback(
    (pin, currentSrc, source) => {
      const param = qs.stringify(
        {
          ...(source ? { from: source } : null),
          ...(searchWord ? { searchWord } : null),
        },
        { addQueryPrefix: true }
      );
      const pinId = pin.pin_id;
      if (pinOpenType === PIN_OPEN_TYPE.BLANK) {
        window.open(`/pins/${pinId}${param}`);
        return;
      }
      if (isModal) {
        // currentSrc用于渐进式显示图片，先显示缓存图，再显示大图
        useAppStore.setState({ currentPin: { pinId, currentSrc, searchWord } });
        let detailsSetp = getNextDetailsSetp();
        let historyData =
          typeof history?.state === "object" ? history?.state : {};
        window.history.pushState(
          { ...historyData, detailsSetp },
          null,
          `/pins/${pinId}${param}`
        );
      } else {
        // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
        window._pinDetailCurrentSrc = currentSrc;
        router.push(`/pins/${pinId}${param}`);
      }
    },
    [isModal, pinOpenType, router, searchWord]
  );

  // 推荐内容：同在画板 和 为你推荐
  const isVideo = useMemo(() => {
    let data = pin || currentPin;
    return (
      data?.file_material?.material_category === "视频模板" ||
      data?.file_material?.material_category === "视频"
    );
  }, [pin, currentPin]);
  const isGif = useMemo(() => {
    let data = pin || currentPin;
    return data?.file?.type === "image/gif";
  }, [pin, currentPin]);

  const onReport = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }

    ReportModal.open({
      reportType: "采集",
      reportPinId: pin?.pin_id,
      reportContentId: pin?.file_material?.material_id,
      reportFileId: pin?.file_id,
      contentType: getContentType(pin),
      onOk: async (values) => {
        const result = await report({
          type: "pin",
          ...values,
          id: pin?.pin_id,
        });
        if (!result.err) {
          HBMessage.success(
            "谢谢你对花瓣的贡献，花瓣的工作人员会及时处理你的举报的"
          );
        } else {
          HBMessage.success("已收到您的举报信息，我们会尽快处理的");
        }
      },
    });
  }, [login, pin, user]);

  const isOfficial = useMemo(() => {
    return config?.officialUsers?.split(",").includes(pin?.user?.urlname);
  }, [pin, config]);

  const isBigCompany = useMemo(() => {
    return isGdMerged(user)
      ? isBigCompanyByGdVip(vips)
      : isBigCompanyByUser(user);
  }, [user, vips]);

  const showSimilarList = useMemo(() => {
    return Boolean(
      !isVideo && !isGif && !isBigCompany && (pin?.pin_id || pinId)
    );
  }, [isVideo, isGif, isBigCompany, pinId, pin?.pin_id]);

  return (
    <div
      className={classNames([styles.detail, isModal ? styles.pt : null])}
      data-search-word={searchWord}
    >
      <When condition={isModal}>
        <ModalOperate
          onClose={onClose}
          nextPin={nextPin}
          prevPin={prevPin}
          onOperation={onOperation}
        ></ModalOperate>
      </When>

      <If condition={notFoundPin && isModal}>
        {/* 没有找到采集，且在弹窗模式下 */}
        <Then>
          <div className={styles.notFound}>
            <HBEmpty
              image="//cdn.dancf.com/fe-assets/img/b6574f8d7ee91f21094691f3ff13d5a9.svg"
              title="Oh~抱歉，访问的采集不存在了"
              subtitle="采集有误或该采集已被删除"
            />
          </div>
        </Then>

        <Else>
          <PinHead pin={pin} isMaterial={isMaterial} />
          <div
            id="pin_detail"
            className={styles.card}
            ref={detailRef}
            data-content-source="采集详情"
            data-content-id={pin?.pin_id}
            data-board-id={pin?.board_id}
            data-material-id={pin?.file_material?.material_id}
            data-file-id={pin?.file_id}
            data-content-type={getContentType(pin)}
          >
            <div className={classNames([styles.img, styles.leftImg])}>
              <Switch>
                <Case condition={isVideo}>
                  <div
                    className={styles.viewer}
                    data-gd-expose="content_expose"
                    data-content-id={pin?.pin_id}
                  >
                    <div
                      className={styles.viewerWrap}
                      // style={{
                      //   maxHeight: `calc(100vh - ${offsetTop}px)`,
                      //   minHeight:
                      //     (pinFile?.height * Math.min(pinFile?.width, 658)) /
                      //     pinFile?.width,
                      // }}
                    >
                      <div
                        className={classNames([
                          styles.viewContent,
                          styles.white,
                        ])}
                      >
                        <video
                          src={pin?.file_material?.extra?.video_mask}
                          style={{
                            top: isModal
                              ? viewStickyTop
                              : headerHeight + viewStickyTop,
                          }}
                          width={658} // 视频一律铺满展示
                          poster={currentSrc}
                          controls
                          loop
                          muted
                          autoPlay
                          preload="metadata"
                          controlsList="nodownload"
                        />
                      </div>
                    </div>
                  </div>
                </Case>
                <Case condition={pinFile}>
                  <div className={classNames([styles.viewer])}>
                    <div
                      className={styles.viewerWrap}
                      // style={{
                      //   maxHeight: `calc(100vh - ${offsetTop}px)`,
                      //   minHeight:
                      //     (pinFile?.height * Math.min(pinFile?.width, 658)) /
                      //     pinFile?.width,
                      // }}
                    >
                      <div
                        className={styles.viewContent}
                        ref={viewContentRef}
                        style={{
                          top: isModal
                            ? viewStickyTop
                            : headerHeight + viewStickyTop,
                        }}
                      >
                        <div
                          className={styles.imageWrap}
                          style={{
                            height:
                              (pinFile?.height *
                                Math.min(pinFile?.width, 658)) /
                              pinFile?.width,
                          }}
                        >
                          <Image
                            className={classNames([
                              "transparent-img-bg",
                              Math.min(pinFile?.width, 658) === 658
                                ? styles.radius
                                : null,
                              styles.zoom,
                            ])}
                            preClassName={styles.pre}
                            key={imageUrl(pinFile, { width: 658 })}
                            src={imageUrl(pinFile, { width: 658 })}
                            srcSet={imageUrl(pinFile, { width: 1200 }) + " 2x"}
                            preSrc={currentSrc}
                            alt={
                              pin?.raw_text ||
                              `${pin?.board?.title}内的花瓣采集图片-${pin?.user?.username}`
                            }
                            width={Math.min(pinFile?.width, 658)}
                            height={
                              (pinFile?.height *
                                Math.min(pinFile?.width, 658)) /
                              pinFile?.width
                            }
                            loading={"eager"}
                            title="点击查看大图 [F]"
                            limit={true}
                            showError={true}
                            fetchpriority={"high"}
                            onClick={onShowPreview}
                            data-gd-expose="content_expose"
                            data-content-id={pin?.pin_id}
                            data-gd-click="button_click"
                            data-button-name="查看大图"
                          />
                          {/* 相似采集按钮 */}
                          <When condition={pin?.trusted !== false}>
                            <Affix
                              target={() =>
                                isModal
                                  ? document.querySelector(".pinDetailModal")
                                  : window
                              }
                              offsetBottom={8}
                              style={{
                                position: "absolute",
                                bottom: "8px",
                                left: "8px",
                              }}
                            >
                              <UserGuideTooltip
                                localStorageKey={
                                  LOCAL_STORAGE_KEY.HB_PIN_SEARCH_SIMILAR_TIP
                                }
                                containerClassName={styles.guideTip}
                                closeClassName={styles.guideTipClose}
                                contentWidth={157}
                                needUserId={false}
                                placement="bottomLeft"
                                type="click"
                                once={true}
                                title="相似搜索能力升级，点击即可体验~"
                              >
                                <Button
                                  className={classNames(
                                    styles.link,
                                    styles.similarLink
                                  )}
                                  data-gd-click="button_click"
                                  data-button-name="搜索相似采集"
                                  href={`/similar?bucket=${
                                    pin?.file?.bucket
                                  }&key=${pin?.file?.key}${
                                    pin?.file_id
                                      ? `&file_id=${pin?.file_id}`
                                      : ""
                                  }&width=${pin?.file?.width}&height=${
                                    pin?.file?.height
                                  }`}
                                  target="_blank"
                                  rel="nofollow"
                                  data-tooltip="搜相似"
                                >
                                  <HBIcon type="ic_search-similar1" />
                                </Button>
                              </UserGuideTooltip>
                            </Affix>
                          </When>
                          <When
                            condition={pin?.source && !pin?.domain?.hide_origin}
                          >
                            <Affix
                              target={() =>
                                isModal
                                  ? document.querySelector(".pinDetailModal")
                                  : window
                              }
                              offsetBottom={8}
                              style={{
                                position: "absolute",
                                bottom: "8px",
                                right: "8px",
                              }}
                            >
                              <a
                                className={styles.link}
                                title={pin?.link}
                                target="_blank"
                                href={`/go?pin_id=${
                                  pin?.pin_id
                                }&url=${encodeURIComponent(pin?.source)}`}
                              >
                                <HBIcon
                                  className={styles.icon}
                                  type="ic_link"
                                />
                                <span className={styles.text}>{pin?.link}</span>
                              </a>
                            </Affix>
                          </When>
                        </div>
                        <PinDetailAiTools
                          pin={pin}
                          isMaterial={isMaterial}
                          user={user}
                        />
                      </div>
                    </div>
                  </div>
                </Case>
              </Switch>
            </div>
            <div className={styles.info} ref={rightContent}>
              <div
                className={styles.action}
                style={{ top: isModal ? 0 : headerHeight }}
              >
                <div className={styles.left}>
                  <ShareDropdown
                    placement="bottomCenter"
                    pics={imageUrl(pinFile)}
                    title="这张来自「花瓣网」的图不错哦，快来看看！"
                  >
                    <div
                      className={styles.share}
                      data-gd-click="button_click"
                      data-button-name="分享"
                    >
                      <HBIcon type="ic_share" />
                    </div>
                  </ShareDropdown>
                  <div
                    className={styles.report}
                    onClick={onReport}
                    title="举报"
                    data-gd-click="button_click"
                    data-button-name="举报"
                    data-report-type="采集"
                    data-report-pin-id={pin?.pin_id}
                    data-report-file-id={pin?.file_id}
                    data-report-content-id={pin?.file_material?.material_id}
                    data-tooltip="举报"
                    data-tooltip-position="bottom"
                  >
                    <HBIcon type="alert" />
                  </div>
                </div>
                <div className={styles.right}>
                  <If condition={user?.user_id === pin?.user_id}>
                    <Then>
                      <Button
                        className={styles.delete}
                        type="text"
                        onClick={onDelete}
                        data-gd-click="button_click"
                        data-button-name="删除"
                      >
                        <HBIcon type="ic_delete" />
                      </Button>
                      <Button
                        className={styles.edit}
                        type="text"
                        onClick={onEdit}
                        data-gd-click="button_click"
                        data-button-name="编辑"
                      >
                        <HBIcon type="ic_edit" />
                      </Button>
                    </Then>
                    <Else>
                      <Button
                        className={classNames([
                          styles.favour,
                          pin?.liked ? styles.active : null,
                        ])}
                        type="text"
                        onClick={onToggleLike}
                        data-gd-click="button_click"
                        data-button-name={pin?.liked ? "取消喜欢" : "喜欢"}
                        data-tooltip={pin?.liked ? "取消喜欢" : "喜欢"}
                        data-tooltip-position="bottom"
                      >
                        <HBIcon
                          type={pin?.liked ? "ic_favorite" : "favorite"}
                        />
                      </Button>
                    </Else>
                  </If>

                  <UserGuideTooltip
                    needUserId={false}
                    visible={userReady && !user}
                    title={
                      <div className={styles.tipContainer}>
                        <div className={styles.tipTitle}>
                          点采集，可以收藏图片哦
                        </div>
                        <div>
                          创建你的在线灵感图库，创作时候能随时随地翻看，提高创作效率
                        </div>
                      </div>
                    }
                    containerClassName={styles.tipContent}
                    localStorageKey={() => "hb_new_user_pin_btn_tooltip"}
                    placement="leftTop"
                  >
                    <PinButton
                      pin={pin}
                      onOk={onPinSuccess}
                      current={true}
                      shortcutOrder={0}
                    />
                  </UserGuideTooltip>
                </div>
              </div>
              <div className={styles.sticky} style={style} ref={stickyRef}>
                <PinTitle pin={pin || currentPin} setPin={setPin}></PinTitle>

                <Switch>
                  <Case condition={isMaterial}>
                    <PinMaterial pin={pin} searchWord={searchWord} />
                  </Case>
                  <Case
                    condition={
                      pin?.file_material?.status ===
                      PIN_MATERIAL_STATUS.MODIFIED
                    }
                  >
                    <PinMaterialRedirect pin={pin} />
                  </Case>
                  <Case condition={pin?.file_aigc}>
                    <PinAIInfo info={pin?.file_aigc} pin={pin} />
                  </Case>
                </Switch>

                {showSimilarList && (
                  <SimilarMaterialList
                    material_id={pin?.extra?.material_id}
                    className={styles.similar}
                    pin_id={newPinId}
                    onSelect={onSelectPin}
                    similiarList={similiarList}
                  />
                )}

                {/* 素材展示主题，其他展示画板 */}
                {pin?.related_topic && isOfficial && !isBigCompany ? (
                  hideRelatedTopicAB.show && (
                    <PinTopic data={pin} isModal={isModal} />
                  )
                ) : (
                  <Board data={pin} setPin={setPin} isModal={isModal} />
                )}

                {/* 用户头像模块 */}
                <User pin={pin || currentPin} setPin={setPin}></User>

                <div className={styles.amount}>
                  转采 {displayNum(pin?.repin_count) || 0} · 喜欢{" "}
                  {displayNum(pin?.like_count) || 0}
                </div>
              </div>
            </div>

            {pin?.file_material?.extra?.group_ids ? (
              <PinSeries pin={pin} onSelect={onSelectPin} isModal={isModal} />
            ) : null}
          </div>
          {/* 推荐 */}

          <Recommend
            isModal={isModal}
            pin={pin}
            showSimilarList={showSimilarList}
            relatedBoards={relatedBoards}
            similiarList={similiarList}
            searchWord={searchWord}
          />
        </Else>
      </If>
    </div>
  );
}
